/**
 * Subtle scroll-in reveal for content blocks. Elements are visible by
 * default in CSS; the .js class (added only once script runs) is what
 * lets sections.css apply the pre-animation state, so removing or
 * disabling this script never hides content.
 */
export function initReveal(): void {
  const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  const targets = document.querySelectorAll<HTMLElement>(".reveal");

  if (reducedMotion || targets.length === 0 || !("IntersectionObserver" in window)) {
    targets.forEach((el) => el.classList.add("is-visible"));
    return;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (entry.isIntersecting) {
          entry.target.classList.add("is-visible");
          observer.unobserve(entry.target);
        }
      }
    },
    // Fires as the element's top crosses the viewport's bottom edge - the
    // IntersectionObserver equivalent of ScrollTrigger's start: "top bottom".
    // The previous 0.2 threshold plus a -10% bottom margin held the reveal
    // back until the block was already well up the screen.
    { threshold: 0, rootMargin: "0px" }
  );

  targets.forEach((el) => observer.observe(el));
}
